module.exports = __webpack_public_path__ + "static/media/border-inner.aedc423e.svg";